import { render, staticRenderFns } from "./CodeExample.vue?vue&type=template&id=52f307f4&"
import script from "./CodeExample.vue?vue&type=script&lang=js&"
export * from "./CodeExample.vue?vue&type=script&lang=js&"
import style0 from "./CodeExample.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports